// @ts-strict-ignore
import clsx from 'clsx'
import { memo } from 'react'

import { CardType } from '../../types/types'

import cl from './name.module.scss'

interface NameProps {
	className?: string
	title: string
	type?: CardType
	unavailable?: boolean
	onClick?: () => void
}

export const Name = memo((props: NameProps) => {
	const { title, className, type, onClick, unavailable = false } = props

	return (
		<div
			onClick={() => onClick?.()}
			className={clsx(cl.name, cl[type], className, {
				[cl.unavailable]: unavailable
			})}>
			<span>{title}</span>
		</div>
	)
})
